export default {
    en: {
        id: 'diagram4b2-9',
        blocks: [
            {
                index: '1',
                task: 'S = Are surrounded by amazing objects',
                title: "S = "
            },
            {
                index: '2',
                task: 'C = Required creative skills to create',
                title: "C = "
            },
            {
                index: '3',
                task: 'Q = How did our species acquire such skills?',
                title: "Q = "
            }
        ],
        answers: [
            {
                index: '2',
                title: 'Required Z'
            },
            {
                index: '3',
                title: 'How acquire Z?'
            },
            {
                index: '1',
                title: 'Surrounded by X'
            },
        ],
        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
        correctAnswers: 3,
        note: `This is an example of an introduction trying to generate a question that no one would ask. The technique of using an anecdote from the author’s life to try to draw the reader in is a perfectly legitimate one. It’s just that this story is not very interesting, and doesn’t really lead us to want to know how the world acquired our technology. But getting the structure down to its bare bones instantly reveals the lack of a justification for including it.`
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4b2/spottingSCQ/i18n/exercise9.js